import axios from 'axios'
import {
  tokenManager,
  errorHandler,
  createStore,
} from './auth.js'

// ------------------------------------
// Constants
// ------------------------------------
export const LOGIN_CONTRACT_USER_REQUEST = 'LOGIN_CONTRACT_USER_REQUEST'
export const LOGIN_CONTRACT_USER_SUCCESS = 'LOGIN_CONTRACT_USER_SUCCESS'
export const LOGIN_CONTRACT_USER_FAILURE = 'LOGIN_CONTRACT_USER_FAILURE'
export const LOGOUT_CONTRACT_USER_REQUEST = 'LOGOUT_CONTRACT_USER_REQUEST'
export const LOGOUT_CONTRACT_USER_SUCCESS = 'LOGOUT_CONTRACT_USER_SUCCESS'
export const LOGOUT_CONTRACT_USER_FAILURE = 'LOGOUT_CONTRACT_USER_FAILURE'
const {
  getToken,
  setToken,
  clearToken,
  getCurrentUserFromToken,
} = tokenManager('authContractToken')

const {
  actions: {
    loginUser,
    logoutUser,
  },
  reducer,
} = createStore({
  ACTION_LOGIN_USER_REQUEST: LOGIN_CONTRACT_USER_REQUEST,
  ACTION_LOGIN_USER_SUCCESS: LOGIN_CONTRACT_USER_SUCCESS,
  ACTION_LOGIN_USER_FAILURE: LOGIN_CONTRACT_USER_FAILURE,
  ACTION_LOGOUT_USER_REQUEST: LOGOUT_CONTRACT_USER_REQUEST,
  ACTION_LOGOUT_USER_SUCCESS: LOGOUT_CONTRACT_USER_SUCCESS,
  ACTION_LOGOUT_USER_FAILURE: LOGOUT_CONTRACT_USER_FAILURE,
  loginUrl: '/login?service=contract',
  logoutUrl: '/logout?service=contract',
  getToken,
  setToken,
  clearToken,
  getCurrentUserFromToken,
})

// ------------------------------------
// Actions
// ------------------------------------
export {
  loginUser,
  logoutUser,
}

// ------------------------------------
// Reducer
// ------------------------------------
export { reducer as default }

// initial axios
export function initAxios ({ dispatch }) {
  axios.interceptors.request.use(config => {
    const token = getToken()
    if (token) {
      config.headers.common['Authorization'] = `JWT ${token}`
    }
    return config
  }, error => Promise.reject(error))

  axios.interceptors.response.use(response => response, (error) => {
    if (error.response) {
      const {
        response: { status },
        config
      } = error
      if (config.url.search('/contracts') !== -1) {
        if (status === 401) {
          errorHandler(dispatch, error.response, LOGIN_CONTRACT_USER_FAILURE)
        }
      }
      error.skipErrorHandling = true
    }

    return Promise.reject(error)
  })
}



// WEBPACK FOOTER //
// ./src/store/authContract.js